import FormAnswerMultipleConnection from './FormSubQuestionConnectionAnswer';
import { FormSubQuestionConnectionAnswerProps } from './type';

export default FormAnswerMultipleConnection;
export type { FormSubQuestionConnectionAnswerProps };
